// extracted by mini-css-extract-plugin
export var container = "_4s-0";
export var icon = "_4s-1";
export var text = "_4s-2";